<div class="ltms-calendar-container" #datepicker [class.response-date]="!appliedDateFilters.isRequestDate">
    <div class="ltms-calendar-button" *ngIf="!datePickerConfig.hide" [class.active]="isDateSelectorOpen" (click)="toggleDateSelector($event)">
        <img class="calendar-icon" src="assets/images/calendar.svg">
        <img class="calender-active-icon" src="assets/images/calendar-active.svg">
        <div class="calendar-text" *ngIf="datePickerConfig.showDateTypeLabel">{{ appliedDateFilters.isRequestDate ? ("HEADER_TEXT_REQUEST_DATE" | translate) :
            ("HEADER_TEXT_REPONSE_DATE" | translate)}}<span class="spacer">-</span> </div>
        <div class="calendar-selected-dates">{{appliedDateFilters.formatedStartDate}}<span class="spacer">-</span>{{appliedDateFilters.formatedEndDate}}
        </div>
    </div>
    <div class="ltms-calendar-datepickers show" *ngIf="datePickerConfig.showCalender" [class.inbox-date-picker]="datePickerConfig.addAllPreset" [class.show]="isDateSelectorOpen" >
    <!-- <div class="ltms-calendar-datepickers show"> -->
        <div class="ltms-calendar-datepicker-body">
            <div class="ltms-calendar-datepicker-left-panel">
                <ul class="ltms-rangetype-selector">
                    <li *ngFor="let rangetype of dateRangeTypes" [class.active]="rangetype.active">
                        <button (click)="selectPreviousDateRange(rangetype)" *ngIf="rangetype.type != 'all'" [disabled]="disabledPrevButton">
                            <img src="assets/images/decrease.svg" />
                        </button>
                        <span class="ltms-rangetype-text"
                            (click)="changeRangeType(rangetype)">{{rangetype.label}}</span>
                        <button (click)="selectNextDateRange(rangetype)" *ngIf="rangetype.type != 'all'" [disabled]="disabledNextButton">
                            <img src="assets/images/increase.svg" />
                        </button>
                    </li>
                </ul>
            </div>
            <div class="ltms-calendar-datepicker-right-panel">
                <div class="ltms-left-datepicker">
                    <!-- <div class="ltms-datepicker-header">
                        <span>January</span><span>2024</span>
                    </div>
                    <div class="ltms-datepicker-range-selector">
                        adfasdfsadfads
                    </div> -->
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    <button [class.active]="!pickerButtons.year.previous"
                                        (click)="changeDatesRange('year',false)">
                                        <img src="assets/images/chevron-double-left.svg" />
                                    </button>
                                </th>
                                <th>
                                    <button [class.active]="!pickerButtons.month.previous"
                                        (click)="changeDatesRange('month',false)">
                                        <img src="assets/images/chevron-left.svg" />
                                    </button>
                                </th>
                                <th class="month-year-label" colspan="5">{{calender.previous.monthName}}
                                    {{calender.previous.year}} </th>
                            </tr>
                            <tr>
                                <th *ngFor="let day of dayShortNames">{{day}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let week of calender.previous.days">
                                <td *ngFor="let day of week" (click)="selectCustomDates(day)"
                                    (mouseover)="isAllowedDateRange($event,day)"
                                    (mouseleave)="clearAllowedDateRange($event)"
                                 [ngClass]="{
                                    'disabled':day.disabled,
                                    'hide':!day.enabled,
                                    'range-start':isStartDate(day),
                                    'in-range':isDateInRange(day),
                                    'range-end':isEndDate(day),
                                    'start-of-month':isStartOfMonth(day),
                                    'end-of-month':isEndOfMonth(day)
                                 }">
                                    {{day.date}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="ltms-right-datepicker">
                    <!-- <div class="ltms-datepicker-header">
                        <span>Fabruary</span><span>2024</span>
                    </div>
                    <div class="ltms-datepicker-range-selector">
                        kasdflasdjf
                    </div> -->
                    <table>
                        <thead>
                            <tr>
                                <th colspan="5" class="month-year-label">
                                    <!-- <select>
                                        <div class="month-selector">
                                            <div class="month-selector-btn">Dropdown</div>
                                            <ul class="month-selector-content">
                                                <li >Link 1</li>
                                                <li >Link 2</li>
                                                <li >Link 3</li>
                                            </ul>
                                        </div>
                                    </select> -->
                                    <!-- <select class="month-selector">
                                        <option *ngFor="let month of monthNames;let i = index" [value]="i">{{month}}
                                        </option>
                                    </select> -->
                                    {{calender.current.monthName}}
                                    {{calender.current.year}}
                                </th>
                                <th>
                                    <button [class.active]="!pickerButtons.month.next"
                                        (click)="changeDatesRange('month',true)">
                                        <img src="assets/images/chevron-right.svg" />
                                    </button>
                                </th>
                                <th>
                                    <button [class.active]="!pickerButtons.year.next"
                                        (click)="changeDatesRange('year',true)">
                                        <img src="assets/images/chevron-double-right.svg" />
                                    </button>
                                </th>

                            </tr>
                            <tr>
                                <th *ngFor="let day of dayShortNames">{{day}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let week of calender.current.days">
                                <td *ngFor="let day of week" (click)="selectCustomDates(day)" 
                                (mouseover)="isAllowedDateRange($event,day)"
                                (mouseleave)="clearAllowedDateRange($event)"
                                [ngClass]="{ 
                                    'disabled':day.disabled,
                                    'hide':!day.enabled,
                                    'range-start':isStartDate(day),
                                    'in-range':isDateInRange(day),
                                    'range-end':isEndDate(day),
                                    'start-of-month':isStartOfMonth(day),
                                    'end-of-month':isEndOfMonth(day)
                                 }">
                                    {{day.date}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="ltms-calendar-datepicker-footer">
            <div class="ltms-datetype-selector" >
                <div class="checkobx-label" *ngIf="datePickerConfig.showDatetypeToggler">View by</div>
                <div class="ltms-checkbox-wrapper" *ngIf="datePickerConfig.showDatetypeToggler">
                    <div class="checkbox-container">
                        <input type="checkbox" id="request_date" [checked]="(isRequestDate)?'checked':''" name="check" value="" />
                        <label for="request_date" (click)="changeDateType($event,true)">
                            <img class="default-img" src="assets/images/checkbox-blank-circle-outline.svg"/>
                            <img class="active-img" src="assets/images/checkBox-circle-fill-svg.svg"/>
                            Request Date
                        </label>
                    </div>
                    <div class="checkbox-container" *ngIf="datePickerConfig.showDatetypeToggler">
                        <input type="checkbox" id="response_date" [checked]="!(isRequestDate)?'checked':''" name="check" value="" />
                        <label for="response_date" (click)="changeDateType($event,false)">
                            <img class="default-img" src="assets/images/checkbox-blank-circle-outline.svg"/>
                            <img class="active-img" src="assets/images/checkBox-circle-fill-svg.svg"/>
                            Response Date
                        </label>
                    </div>
                </div>
            </div>
            <div class="ltms-action-buttons">
                <button class="reset-button" (click)="changeRangeType(resetRangeType)">Reset</button>
                <button class="apply-button" [disabled]="!isStartDateSelected || !isEndDateSelected" (click)="apply()">Apply</button>
            </div>
        </div>
    </div>
    <div class="ltms-quick-presest-selector" *ngIf="datePickerConfig.showPreset" [class.show]="isDateSelectorOpen">
        <ul class="ltms-quick-presest-list">
            <li class="litmus-checkbox-control">
                <input type="checkbox" id="last_week_preset" [checked]="(activeRangeType.type == 'week')?'checked':''" name="check" value="" />
                <label for="last_week_preset" (click)="onQuickPresetChange($event,'week')">
                    <img class="default-img" src="assets/images/checkbox-blank-circle-outline.svg"/>
                    <img class="active-img" src="assets/images/checkBox-circle-fill-svg.svg"/>
                    Last week
                </label>
            </li>
            <li class="litmus-checkbox-control">
                <input type="checkbox" id="last_month_preset" [checked]="(activeRangeType.type == 'month')?'checked':''" name="check" value="" />
                <label for="last_month_preset" (click)="onQuickPresetChange($event,'month')">
                    <img class="default-img" src="assets/images/checkbox-blank-circle-outline.svg"/>
                    <img class="active-img" src="assets/images/checkBox-circle-fill-svg.svg"/>
                    Last month
                </label>
            </li>
            <li class="litmus-checkbox-control">
                <input type="checkbox" id="last_year_preset" [checked]="(activeRangeType.type == 'quarter')?'checked':''" name="check" value="" />
                <label for="last_year_preset" (click)="onQuickPresetChange($event,'quarter')">
                    <img class="default-img" src="assets/images/checkbox-blank-circle-outline.svg"/>
                    <img class="active-img" src="assets/images/checkBox-circle-fill-svg.svg"/>
                    Last quarter
                </label>
            </li>
        </ul>
    </div>
</div>